// Get the current mouse position
export default function getMousePos({ event, canvas }) {
    const rect = canvas.getBoundingClientRect();
    return {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top
    };
}